export enum SIDE_NAV_STATE {
    EXPANDED = 'expanded',
    MINIMIZED = 'minimized'
}